import { ReactNode } from 'react';
import Navigation from '@components/main/navigation';

interface LayoutProps {
	children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
	return (
		<div className='h-screen flex flex-col'>
			<div className='w-full flex-none justify-center'>
				<Navigation />
			</div>
			<div className='h-full flex-grow overflow-y-auto'>{children}</div>
		</div>
	);
};

export default Layout;
